export default __webpack_public_path__ + "static/support-e3df72406d251761f48b8517dabc4487.webp";